import {
    CommunitiesHeader,
    Desire,
    ProductsList,
    SharedValues,
    TestimonialDesire,
    JoinUs,
} from '@components'

export const Communities = () => {
    return (
        <>
            <CommunitiesHeader />
            <Desire />
            <ProductsList />
            <SharedValues />
            <JoinUs />
            <TestimonialDesire />
        </>
    )
}
